// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CustomFieldInputPayload,
    CustomFieldInputPayloadFromJSON,
    CustomFieldInputPayloadToJSON,
    TestCaseStepsPayload,
    TestCaseStepsPayloadFromJSON,
    TestCaseStepsPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface TestCasePayload
 */
export interface TestCasePayload {
    /**
     * 
     * @type {string}
     * @memberof TestCasePayload
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof TestCasePayload
     */
    suite?: number;
    /**
     * 
     * @type {number}
     * @memberof TestCasePayload
     */
    project: number;
    /**
     * 
     * @type {string}
     * @memberof TestCasePayload
     */
    issueKey?: string;
    /**
     * 
     * @type {string}
     * @memberof TestCasePayload
     */
    im?: string;
    /**
     * 
     * @type {string}
     * @memberof TestCasePayload
     */
    issueId?: string;
    /**
     * 
     * @type {string}
     * @memberof TestCasePayload
     */
    instanceId?: string;
    /**
     * HTML-formatted test case description (generated by rich text editor)
     * @type {string}
     * @memberof TestCasePayload
     */
    description?: string;
    /**
     * 
     * @type {Array<TestCaseStepsPayload>}
     * @memberof TestCasePayload
     */
    steps?: Array<TestCaseStepsPayload>;
    /**
     * Priority, 0 - Low, 1- Normal, 2 - High
     * @type {number}
     * @memberof TestCasePayload
     */
    priority?: TestCasePayloadPriorityEnum;
    /**
     * Tag IDs array
     * @type {Array<number>}
     * @memberof TestCasePayload
     */
    tags?: Array<number>;
    /**
     * Array of file ids
     * @type {Array<string>}
     * @memberof TestCasePayload
     */
    attachments?: Array<string>;
    /**
     * Array of custom fields
     * @type {Array<CustomFieldInputPayload>}
     * @memberof TestCasePayload
     */
    customFields?: Array<CustomFieldInputPayload>;
    /**
     * Requirement IDs array
     * @type {Array<number>}
     * @memberof TestCasePayload
     */
    requirements?: Array<number>;
    /**
     * Comment by poster/editor (applicable when test case review feature is enabled)
     * @type {string}
     * @memberof TestCasePayload
     */
    posterComment?: string;
    /**
     * Reviewer Id (applicable when test case review feature is enabled)
     * @type {number}
     * @memberof TestCasePayload
     */
    reviewer?: number;
    /**
     * Review Status (applicable when test case review feature is enabled)
     * @type {number}
     * @memberof TestCasePayload
     */
    reviewStatus?: number;
    /**
     * JSON string containing auto info - only available when test automation is enabled
     * @type {string}
     * @memberof TestCasePayload
     */
    autoInfo?: string;
    /**
     * Default assignee user ID. Automatically assigned when this test case is added to a test plan. Must be an active project member who can execute test cases. Send null to clear.
     * @type {number}
     * @memberof TestCasePayload
     */
    defaultAssignee?: number;
}

export function TestCasePayloadFromJSON(json: any): TestCasePayload {
    return {
        'title': json['title'],
        'suite': !exists(json, 'suite') ? undefined : json['suite'],
        'project': json['project'],
        'issueKey': !exists(json, 'issue_key') ? undefined : json['issue_key'],
        'im': !exists(json, 'im') ? undefined : json['im'],
        'issueId': !exists(json, 'issue_id') ? undefined : json['issue_id'],
        'instanceId': !exists(json, 'instance_id') ? undefined : json['instance_id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'steps': !exists(json, 'steps') ? undefined : (json['steps'] as Array<any>).map(TestCaseStepsPayloadFromJSON),
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'attachments': !exists(json, 'attachments') ? undefined : json['attachments'],
        'customFields': !exists(json, 'custom_fields') ? undefined : (json['custom_fields'] as Array<any>).map(CustomFieldInputPayloadFromJSON),
        'requirements': !exists(json, 'requirements') ? undefined : json['requirements'],
        'posterComment': !exists(json, 'poster_comment') ? undefined : json['poster_comment'],
        'reviewer': !exists(json, 'reviewer') ? undefined : json['reviewer'],
        'reviewStatus': !exists(json, 'review_status') ? undefined : json['review_status'],
        'autoInfo': !exists(json, 'auto_info') ? undefined : json['auto_info'],
        'defaultAssignee': !exists(json, 'default_assignee') ? undefined : json['default_assignee'],
    };
}

export function TestCasePayloadToJSON(value?: TestCasePayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'title': value.title,
        'suite': value.suite,
        'project': value.project,
        'issue_key': value.issueKey,
        'im': value.im,
        'issue_id': value.issueId,
        'instance_id': value.instanceId,
        'description': value.description,
        'steps': value.steps === undefined ? undefined : (value.steps as Array<any>).map(TestCaseStepsPayloadToJSON),
        'priority': value.priority,
        'tags': value.tags,
        'attachments': value.attachments,
        'custom_fields': value.customFields === undefined ? undefined : (value.customFields as Array<any>).map(CustomFieldInputPayloadToJSON),
        'requirements': value.requirements,
        'poster_comment': value.posterComment,
        'reviewer': value.reviewer,
        'review_status': value.reviewStatus,
        'auto_info': value.autoInfo,
        'default_assignee': value.defaultAssignee,
    };
}

/**
* @export
* @enum {string}
*/
export enum TestCasePayloadPriorityEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}


